import {connect} from '../../app/connect';
import IssueSummary from './IssueSummary';
import {
  getDocumentRevision,
  getDocumentRevisionByVersion,
  getLocationsTreeNodesDictionary,
  getIsLocationsLoadingError,
  getIsLocationsTreeLoading,
  getUserNameWithCompanyGetter
} from '../../app/selectors';
import {getLinkedDocument} from '../../utils/issues-helpers';

const mapStateToProps = (state, ownProps) => {
  const {urn, createdAtVersion} = getLinkedDocument(ownProps.issue);
  const issueStartingRevision = getDocumentRevisionByVersion(state, {urn, version: createdAtVersion});
  const isCurrentRevision = issueStartingRevision === getDocumentRevision(state, urn);
  return {
    isLocationsTreeLoading: getIsLocationsTreeLoading(state),
    isLocationsLoadingError: getIsLocationsLoadingError(state),
    locationsTreeNodesDictionary: getLocationsTreeNodesDictionary(state),
    issueStartingRevision,
    isCurrentRevision,
    getEntityDisplayNameById: getUserNameWithCompanyGetter(state)
  };
};

export default connect(
  mapStateToProps,
  {}
)(IssueSummary);
